import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import { styled as styling } from "@mui/material/styles";
import Color from "../../../assets/colors";
import { FontSize } from "../../../assets/font";

// Grid Components //
export const DiscoverCompaniesContainer = styling(Grid)({
  position: "relative",
  width: "100%",
  maxWidth: "1200px",
  padding: "16px",
  margin: "0 auto 0px auto",
  borderRadius: "20px",
  overflow: "hidden",
  backgroundColor: Color.homepageGrey,
});

// Anchors the overlay to the image itself rather than the padded container
export const BannerFrame = styling("div")({
  position: "relative",
  width: "100%",
  borderRadius: "10px",
  overflow: "hidden",
});

export const BannerImage = styling("img")(({ theme }) => ({
  width: "100%",
  height: "auto",
  display: "block",
  borderRadius: "10px",
  [theme.breakpoints.down("mobileL")]: {
    display: "none",
  },
}));

export const MobileBannerImage = styling("img")(({ theme }) => ({
  width: "100%",
  height: "auto",
  display: "none",
  borderRadius: "10px",
  [theme.breakpoints.down("mobileL")]: {
    display: "block",
  },
}));

export const OuterContainer = styling(Grid)({
  backgroundColor: Color.homepageGrey,
});

export const DecoyGrid = styling(Grid)({
  minHeight: "120px",
  backgroundColor: Color.homepageGrey,
  margin: "0 auto 0px auto",
  position: "static",
  maxWidth: "1026px",
});

export const GradientOverlay = styling(Grid)(({ theme }) => ({
  position: "absolute",
  top: 0,
  left: 0,
  bottom: 0,
  right: 0,
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "flex-start",
  gap: "clamp(0.5rem, 2%, 1.25rem)",
  // Percentages keep the inset proportional to the image at every width
  padding: "5% 6%",
  overflow: "hidden",
  borderRadius: "10px",
  // background: `linear-gradient(
  //       to bottom right,
  //       rgba(81, 42, 204, 0.8),
  //       rgba(0, 0, 0, 0) 60%
  //     )`,
}));

export const TitleContainer = styling(Grid)(({ theme }) => ({
  width: "50%",
  minHeight: 0,
  overflow: "hidden",
  [theme.breakpoints.down("tablet")]: {
    width: "100%",
    alignSelf: "center",
    textAlign: "center",
  },
}));

// Typography Components
export const TitleStyled = styling(Typography)(({ theme }) => ({
  fontSize: `clamp(1rem, 2.6vw, ${FontSize.desktopDisplay2})`,
  fontWeight: FontSize.bold,
  color: Color.white,
  lineHeight: 1.2,
  [theme.breakpoints.down("tablet")]: {
    fontSize: `clamp(0.875rem, 4.2vw, ${FontSize.desktopHeader})`,
  },
}));

export const LinkStyled = styling(Link)({
  display: "block",
  textDecoration: "none",
  color: "inherit",
  cursor: "pointer",
});

// Visual CTA only — the parent LinkStyled owns the click
export const BannerCta = styling("span")(({ theme }) => ({
  display: "inline-flex",
  alignSelf: "flex-start",
  alignItems: "center",
  justifyContent: "center",
  minWidth: "200px",
  height: "50px",
  padding: "10px 20px",
  border: `1px solid ${Color.white}`,
  borderRadius: "30px",
  color: Color.white,
  fontSize: FontSize.desktopBody,
  fontWeight: FontSize.bold,
  lineHeight: 1.2,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  [theme.breakpoints.down("mobileL")]: {
    alignSelf: "center",
  },
}));
